//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "approval-sup-deal",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      showDetail:false,
      objDetail:{},
      listType:'',
      config:{
        title:'商品登记',
        url:'api/SupProductLibDt/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'供应商名称/编号',
          searchCondition:'key',
          rules:[{field: "supplier.supplierName-supplier.supplierCode", option: "LIKE_ANYWHERE"}]
        },
      },
      configTodo:{
        title:'商品登记',
        url:'api/SupProductLib/page',
        workflowSearchBean:{},
        fixRules:{},
      },
      supConfig:{
        title:'商品登记',
        url:'api/SupProductLibDt/page',
        workflowSearchBean:{},
        fixRules:{}
      },
      list:[],
      productStatus:[
        {name:'下架',code:'lowershelf'},
        {name:'上架',code:'uppershuelf'},
        {name:'审批中',code:'apping'},
        {name:'删除',code:'deleted'},
        {name:'审批通过',code:'apped'}
        ]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    goDetail(item){
      if(this.listType === 'deal'){
        this.$router.push(`/workflow/${item.requestId}?component=SupGoodsViewComponent`);
      }else{
        this.$router.push(`/workflow/${item.supProductLib.requestId}?component=SupGoodsViewComponent`);
      }
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/supProductLib').then(data=>{
        this.config.workflowSearchBean={
          workflowId:data.workflowType
        };
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
        };
        this.$refs.header.getlist();
      })
    },
  },
  mounted(){
    this.listType = this.$route.params.listType;
    this.init();
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/goods/sup-goods-list.vue